import { FC } from 'react';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { Body, ThemeProvider } from '@fcc/ui';
import { AppInit } from '@modules/app-init';
import { routes } from './routes';
import { queryClient } from './query-client';
import { store } from '../store';
import { AppProps } from './types';
import { DEFAULT_THEME } from './theme';
import '@lib/request/setup-request';

const Routes = () => useRoutes(routes);

export const App: FC<AppProps> = ({ locale, apiPrefix, basename }) => {
    return (
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider theme={DEFAULT_THEME}>
                    <BrowserRouter basename={basename}>
                        <AppInit locale={locale} apiPrefix={apiPrefix}>
                            <Body>
                                <Routes />
                            </Body>
                        </AppInit>
                    </BrowserRouter>
                </ThemeProvider>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </Provider>
    );
};
